module.exports = __webpack_public_path__ + "static/img/6.4c04cf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/6.png
// module id = IlBE
// module chunks = 0